// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  production: false,
  defaultauth: 'firebase',
  cf_base: 'https://us-central1-fitlego-e1026.cloudfunctions.net',
  challenge_cf_base: 'https://tracker.fitlego.com/login/',
  firebaseConfig: {
    apiKey: 'AIzaSyBJWD3_7vSAjAZ6k0-zK50Sh7I2Yv7NKU8',
    authDomain: 'fitlego-e1026.firebaseapp.com',
    databaseURL: 'https://fitlego-e1026-default-rtdb.firebaseio.com',
    projectId: 'fitlego-e1026',
    storageBucket: 'fitlego-e1026.appspot.com',
    messagingSenderId: '845229506812',
    appId: '1:845229506812:web:a2a6962517ce9066ea1779',
    measurementId: 'G-BVVMFWDTBN'
  },
   stripe: {
    // publicKey: 'pk_live_51JU8ZMKlK1d0C7DN8U3OMVhNonWw8nhfJl4mMaPMk4bdmPPpWQ5ypiMR2NYAhjVUH5yIFef90EuRB6sf5b0tG30T00vnudItze',
    publicKey: 'pk_test_51RdkmR082hlELHqiMCa6zn5uJ3MZWS3AbtbwuSVNTuf4SCpFwQgbxYQfjc1ph73P1i8WYujn9881ggtveGxQvb1Y00KS5V3LM7',
    apiCrateSessionUrl: 'https://donation.fitlygo.com/api/stripe/create/session',
    // apiCrateSessionUrl: 'http://localhost:8000/api/stripe/create/session',
    apiToken: '9e3d9a992920e54a4d58c1b297a35ba0693c24f75d14c9738fc9b7801654e7bb',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
